import { Page, Spinner } from "@patternfly/react-core";
import { Header } from "@keycloak/keycloak-account-ui";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { PageNav } from "./PageNav";

/* Chrome layout for the standard account pages: Keycloak's masthead plus our
 * own nav (which includes an "Overview" link back to the Hub landing page). */
function App() {
  return (
    <Page header={<Header />} sidebar={<PageNav />} isManagedSidebar>
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    </Page>
  );
}

export default App;
